export interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: 1,
    question: "What is ItaobuySpreadsheet?",
    answer: "ItaobuySpreadsheet is a structured shopping spreadsheet system designed to help online shoppers discover products, compare prices, and make smarter purchasing decisions. It combines curated product listings, price data, and easy-to-use filters into one organized platform that saves time and money.",
  },
  {
    id: 2,
    question: "Is ItaobuySpreadsheet safe to use?",
    answer: "Yes, ItaobuySpreadsheet is an informational and product discovery system. We do not process payments, sell products directly, or store sensitive financial information. Users should always verify individual sellers and understand third-party risks before making any purchase. The platform is designed to provide transparent, organized data to support informed shopping decisions.",
  },
  {
    id: 3,
    question: "How does the price comparison feature work?",
    answer: "The price comparison feature organizes product listings with up-to-date pricing from multiple sources within a structured spreadsheet format. You can sort by price range, filter by category, and quickly identify the best value options. This organized approach eliminates the need to manually browse dozens of websites and helps you spot genuine deals faster.",
  },
  {
    id: 4,
    question: "How often are the product lists updated?",
    answer: "Product lists on ItaobuySpreadsheet are refreshed regularly to reflect current availability, pricing changes, and new trending items. The exact update frequency varies by category, but our goal is to maintain accurate and actionable data so you always have access to relevant shopping information when you need it.",
  },
];